import { find as _find } from 'lodash';

class EnquiryBasicDetailsController {
  constructor(authService, appConfig, enums, $scope, $state, enquirySourcesManagementService) {
    "ngInject";

    this.enums = enums;
    this.authService = authService;
    this.$scope = $scope;
    this.$state = $state;
    this.enquirySourcesManagementService = enquirySourcesManagementService;

    this.enquirySources = [];

    this.searchUsersUrl = `${appConfig.apiServiceBaseUri}api/user/search/${authService.authData.currentLocation.key}/`;

    this.enumList = [
      {enumName: 'ENQUIRY_ORIGINATION', propName: 'enquiryOrigination', defaultOption: true},
      {enumName: 'ENQUIRY_CONTACT', propName: 'enquiryContact', defaultOption: true},
    ];

    this.ownerSelected = this.ownerSelected.bind(this);

    $scope.$on('enquiry:initialized', this.setInitialState.bind(this));

    this.setInitialState();

    this.personTitles = this.convertEnumToKeyValueList(enums.PERSON_TITLE);
  }

  setInitialState() {
    /*
    * This method will be called First when initialize this component
    * Second when its recieved an event enquiry:initialized
    * which will signal that enquiry is in edit mode
    */

    const ctrl = this;

    ctrl.selectOptions = {};
    ctrl.selectDefaults = {};

    ctrl.initializeEnums();
    ctrl.initializeEnquirySources();

    if (!ctrl.enquiry.enquiryId) {
      /*
      * We need to check if the enquiry already has an OwnerId.
      * This means that this is not the first time this screen is loaded
      * We are redirected back to this screen after creating a contact,
      * Adding a vehicle / price book vehicle or any other external screen
      */
      if (!ctrl.enquiry.ownerId) {
        ctrl.enquiry.ownerId = ctrl.authService.authData.userId,
        ctrl.enquiry.ownerName = ctrl.authService.authData.firstName + ' ' + ctrl.authService.authData.lastName;
      }

      ctrl.initialOwnerName = ctrl.enquiry.ownerName;
    }
    else {
      ctrl.initialOwnerName = ctrl.enquiry.ownerName;

      //Dirty hack ! but no choice, should not be setting it directly using jQuery
      $('#searchUsers input').val(ctrl.enquiry.ownerName);

      ctrl.enumList.map(item => {
        const selectedOption = _find(ctrl.selectOptions[item.propName], o => o.id === ctrl.enquiry[item.propName]);

        ctrl.selectDefaults[item.propName] = selectedOption;
      });
    }

    ctrl.configureForm();
  }

  configureForm() {
    const ctrl = this;

    ctrl.formValidationService.addField({
      fieldName: 'subject',
      displayName: 'Subject',
      required: true
    });

    ctrl.formValidationService.addField({
      fieldName: 'amountToSpend',
      displayName: 'Amount To Spend',
      type: 'int',
      allowedDecimals: 2
    });

    ctrl.formValidationService.addField({
      fieldName: 'enquiryOrigination',
      displayName: 'Enquiry Origination',
      required: true,
      type: 'select'
    });
  }

  ownerSelected(item) {
    if (item) {
      this.enquiry.ownerId = item.originalObject.userId;
      this.enquiry.ownerName = item.originalObject.firstName + ' ' + item.originalObject.lastName;
    }
  }

  initializeEnums() {
    const ctrl = this;

    ctrl.enumList.map(item => {
      const enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption);
      ctrl.selectOptions[item.propName] = enumsArray;
      ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
      ctrl.updateModelFromSelect(item.propName);
    });
  }

  getDefaultOption(enumsArray, propName) {
    let propVal;

    try {
      propVal = eval(`this.enquiry.${propName}`);
    }
    catch(e) { }

    if (propVal) {
      return _find(enumsArray, o => o.id === propVal);
    }
    else {
      return enumsArray[0];
    }
  }

  convertEnumToKeyValueList(enumObj, defaultOption) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  updateModelFromSelect(modelProperty, selectDefaultProperty = modelProperty, idProperty = 'id') {
    const val = this.selectDefaults[selectDefaultProperty][idProperty];

    try {
      eval(`this.enquiry.${modelProperty} = ${val}`);
    }
    catch(e) { }
  }

  initializeEnquirySources() {
    const ctrl = this;

    ctrl.enquirySourcesManagementService.list(ctrl.authService.authData.currentLocation.key, true)
      .then(response => {
        ctrl.enquirySources = response.data;
        ctrl.enquirySources.unshift({enquirySourceId: null, name: 'Please Select'});
      });
  }

  editContact() {
    const origin = {
      source: 'enquiry',
      processResult: this.getReturnParams.bind(this),
    };

    this.$state.go('contactEdit', {contactId: this.enquiry.contactId, origin: origin})
  }

  getReturnParams(newContactId, contact) {
    return {
      stateName: 'enquiryEdit',
      params: {enquiryId: this.enquiry.enquiryId, activeTab: 'basicDetails'}
    }
  }
}

export default EnquiryBasicDetailsController;



// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryBasicDetails/enquiryBasicDetails.controller.js